function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addMonths } from "../../utils";
import { listRamosGenerales, listRamosByCode, listCurrencies } from "../../../../utils/data";
import { transformDataToOption } from "../../../../utils/SelectUtils";

var ProposedIncome = function ProposedIncome(props) {
  var companiesOption = props.companiesOption,
      _onChange = props.onChange,
      poliza = props.poliza,
      companies = props.companies,
      channels = props.channels;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      firstTime = _React$useState2[0],
      setFirstTime = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      listRamos = _React$useState4[0],
      setListRamos = _React$useState4[1];

  var selectedCompany = companiesOption.find(function (option) {
    return parseInt(option.value) === poliza.company_id;
  });
  var channelsOptions = channels && channels.map(function (channel) {
    return {
      label: channel.name,
      value: channel.id
    };
  });
  var selectedChannel = channelsOptions.find(function (channel) {
    return channel.value === poliza.channel_id;
  });

  var checkIfClearSelectedRamo = function checkIfClearSelectedRamo() {
    if (firstTime) return setFirstTime(false);
    return _onChange({
      ramo: null
    }); //clear selected ramo when change options
  };

  var checkListRamos = function checkListRamos() {
    if (selectedCompany && selectedCompany.value) {
      checkIfClearSelectedRamo();
      var companyData = companies.find(function (company) {
        return company.id == selectedCompany.value;
      });

      if (companyData) {
        var ramosByCode = listRamosByCode.find(function (company) {
          return company.code == companyData.code;
        });

        if (ramosByCode) {
          return setListRamos(transformDataToOption(ramosByCode.ramos));
        }
      }
    }

    return setListRamos(transformDataToOption(listRamosGenerales));
  };

  React.useEffect(function () {
    checkListRamos();
  }, [selectedCompany]);
  var currencyTypes = transformDataToOption(listCurrencies);
  var selectedCurrency = poliza.currency && {
    label: poliza.currency,
    value: poliza.currency
  };
  var selectedRamo = poliza.ramo && {
    label: poliza.ramo,
    value: poliza.ramo
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Compa\xF1\xEDa"), /*#__PURE__*/React.createElement(Select, {
    options: companiesOption,
    value: selectedCompany,
    name: "poliza[company_id]",
    isSearchable: true,
    isClearable: true,
    placeholder: "Selecciona Compañia...",
    onChange: function onChange(item) {
      return _onChange({
        company_id: item.value
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Ramo"), /*#__PURE__*/React.createElement(Select, {
    options: listRamos,
    value: selectedRamo,
    isSearchable: true,
    isClearable: true,
    placeholder: "Selecciona Ramo...",
    onChange: function onChange(item) {
      return _onChange({
        ramo: item === null || item === void 0 ? void 0 : item.value
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Canal"), /*#__PURE__*/React.createElement(Select, {
    options: channelsOptions,
    value: selectedChannel,
    isSearchable: true,
    isClearable: true,
    placeholder: "Selecciona canal...",
    onChange: function onChange(item) {
      return _onChange({
        channel_id: item === null || item === void 0 ? void 0 : item.value
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Fecha de emisi\xF3n"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    selected: poliza.emission_date,
    onChange: function onChange(item) {
      _onChange({
        emission_date: item,
        first_expiration_date: addMonths(item, 1)
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Moneda"), /*#__PURE__*/React.createElement(Select, {
    options: currencyTypes,
    value: selectedCurrency,
    isSearchable: true,
    isClearable: true,
    placeholder: "Selecciona Moneda...",
    onChange: function onChange(item) {
      return _onChange({
        currency: item.value
      });
    }
  }))));
};

export default ProposedIncome;